import { MeetCompleted } from '@/components';
import { useLocation } from 'react-router';

const MeetCompletedPage = () => {
	const { state } = useLocation();

	return (
		<MeetCompleted
			interactionId={state?.socketData?.meetingCreated?.interactionId || state?.socketData?.connectionData?.interactionId}
			type={state?.socketData?.meetingCreated?.liveServiceGroup || state?.socketData?.connectionData?.connectionApp}
			studentId={state?.socketData?.matchApproved?.studentId || state?.socketData?.connectionData?.userInfos?.studentId}
		/>
	);
};

export default MeetCompletedPage;
